<template>
  <div class="mockup">
    <div class="file-section">
      <span v-if="!isAdmin && images.length == 0" >No Mockup for approval yet</span>
      <div v-if="!isLoading" :class="[images.length == 0 ? 'mockup-wrapper-default' :'mockup-wrapper']"> 
        <adx-gallery-slideshow 
        :images="images"
        :imageStyle="imageStyle" :wrapperStyle="wrapperStyle" :title="images"
        :eyeIconStyle="eyeIconStyle" @deletedImage="delImage" @downloadedImg="downloadImg"/>
      </div>
      <div v-else class="media__loading">
        <loading-secondary/>
      </div>
      <div v-if="isAdmin" class="upload-box" @click="launchFilePicker()">
        <input 
          type="file" 
          accept=".jpg, .png" 
          @change="getFile($event)" 
          ref="fileUpload"
          :name="`fileUpload`" 
          :id="`fileUpload`" 
          style="display: none;">
        <span >Browse file to upload</span>
      </div>
      <button v-if="images.length && isAdmin" class="btn-small primary mockup" @click.stop="toggleModal(1)">Send Mockup File</button>
    </div>
    <div class="mockup-action-button">
      <button v-if="images.length && !isAdmin" class="btn-small primary approve" @click.stop="mockupApprove">
        <adx-loading-2 v-if="isApprove" />
        <span v-else>Approve</span> 
      </button>
      <button v-if="images.length && !isAdmin" class="btn-small secondary reject" @click.stop="toggleModal(2)">
        Reject
      </button>
    </div>
  <!-- Modal -->
    <modal v-if="isMockupModal"  :noTitle="true" @modal-close="toggleModal(1)" :type="'small'">
      <div class="mockup__mockup-modal" slot="content">
          <h2 class="medium-title">Mockup Already Sent</h2>
            <div class="label">
              <span> You already sent the mockup before, are you sure want to resend the mockup?</span>
            </div>
          <div class="mockup__mockup-modal__buttons" >
            <button class="btn-large primary resend" @click.stop="resendMockup">Resend</button>
            <button class="btn-large primary cancel btn-white" @click="toggleModal(1)">Cancel</button>
          </div>
      </div>
    </modal>
    <modal v-if="isReject" :noTitle="true" @modal-close="toggleModal(2)" :type="'small'">
      <div class="mockup__mockup-modal" slot="content">
            <h2 class="medium-title">Reason for Rejection</h2>
            <div class="label">
              <span>Please tell us the reason for rejection and we will back with the new mockup in the next 24 hours.</span>
            </div>
            <div class="label">
              <adx-input :label="`Leave a message`" :value.sync="rejectMessage"/>
            </div>
          <div class="mockup__mockup-modal__buttons" >
            <button class="btn-large primary resend" @click.stop="mockupRejection">
              Submit
              <adx-loading-2 v-if="isSubmitRejection" />
            </button>
            <button class="btn-large primary resend btn-white" @click.stop="toggleModal(2)">Cancel</button>
          </div>
        </div>
      </modal>
    <adx-top-alert ref="alert" :status="status" :message="message" visible="visible"/>
  </div>
</template>

<script>

import GallerySlideShow from '@/components/GallerySlideShow'
import Modal from '@/components/Modal'
import Media from 'vue-media'
import file from '@/components/File'
import Input from '@/components/Form/Input'
import TopAlert from '@/components/AlertWide'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingWhite from '@/components/Loading/Secondary-white';

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters } from 'vuex';
import { constants } from 'crypto';
import { parseErrorGql } from '@/lib/error'

export default {
  name: 'adx-',
  components: {
    'adx-gallery-slideshow': GallerySlideShow,
    'modal': Modal,
    'media': Media,
    "adx-file": file,
    'adx-input': Input,
    'adx-top-alert': TopAlert,
    'loading-secondary': LoadingSecondary,
    'adx-loading-2': LoadingWhite,
  },
  props: {

  },
  data() {
    return {
      id: null,
      mockupID: null,
      available: false,
      isMockupModal: false,
      isAdmin: null,
      isApprove: false,
      isSubmitRejection: false,
      isReject: false,
      isLoading: false,
      rejectMessage: null,
      userName: null,
      status:"Success!",
      message:"Your file has sent successfully",
      visible:true,
      imageIds: [],
      images: [],
      title: null,
      totalPrice: 0,
      imageStyle: {
        "width": "132px",
        "height": "132px",
        "margin-bottom": "24px",
        "margin-left": "5px"
      },
      eyeIconStyle: {
        "font-size": "32px",
        "margin-top": "50px",
        "margin-left": "50px",
      },
      wrapperStyle: {
        "display": "grid",
        "grid-gap": "0px",
        "grid-template-columns": "repeat(4, minmax(150px, 1fr))"
      },
    }
  },
  computed: {
    ...mapGetters({
      user: 'account',
      token: 'token',
      profile: 'profile'
    })
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
     this.id = this.$route.params.id
  },
  mounted() {
    localStorage.setItem('apollo-token', this.token)
    this.isAdmin = this.user.isStaff
    this.userName = this.profile.full_name
    this.busOrder()
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busOrder(){
      const data = await  this.$apollo.query({
        query:require('@/graphql/bus/busOrderDetail.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: this.$route.params.id
        }
      })
      if (data.data){
        if (data.errors){
          this.handleError(data.errors)
        } else{
          const { busOrder } = await data.data
          if (busOrder) {
            await this.mapData(busOrder)
          }
        }
        this.isLoading = false
      }
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          this.count++
          if (this.count<3) {
            await this.busCampaign()
          } else{
            this.showNotification()
          } 
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    showNotification(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async mapData(busOrder){
      this.mockupID = await busOrder.mockup.id ? await busOrder.mockup.id : 1
      this.images = []
      this.imageIds = []
      if(busOrder.mockup.contents){
        await busOrder.mockup.contents.forEach(element => {
        this.images.push(element.content_url);
        this.imageIds.push({id:parseInt(element.id)});
        });
      } else {
        this.images = []
        this.imageIds = []
      }
      this.title = await busOrder.campaign.title
      this.totalPrice = await busOrder.campaign.totalPrice
    },
    launchFilePicker() {
      this.$refs.fileUpload.click()
    },
    delImage(index) {
      this.images.splice(index, 1)
      this.imageIds.splice(index, 1)
      this.updateOrder()
    },      
    toggleModal(index){
      if(index == 1){
        this.isMockupModal= !this.isMockupModal
      } else if(index == 2){
        this.isReject = !this.isReject
      }
    },
    getFile(event) {
      let reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = (e) => {
        this.images.push(e.target.result)
        this.saveFile(event.target.files[0])
      }
    },
    async saveFile(fileData) {
      this.isLoading = true
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/uploadFile.gql'),
        errorPolicy: 'all',
        variables: {
          content : {file:fileData}
        },
      });
      this.isLoading = false
      if(result.data && !result.errors) {
        this.imageIds.push({id: parseInt(result.data.uploadFile.id)})
        var child = this.$refs.alert;
        child.fadeout()
      }else {
        this.errorNotify()
      }
      this.updateOrder() 
    },
    async updateOrder(){
      this.isLoading = true
      let imageMapId = []
      this.imageIds.map(img =>{
        imageMapId.push(
          img.id
        )});
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/updateMockupByOrder.gql'),
        errorPolicy: 'all',
        variables: {
          id: this.id,
          busOrder: {
            fileId : imageMapId
          }
        },
      });
      this.isLoading = false
      if (result.data){
          await this.busOrder()
          this.isLoading = false
      }else {
        this.errorNotify()
      }
    },
    async mockupApprove(){
      this.isApprove = true
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/updateMockupStatus.gql'),
        errorPolicy: 'all',
        variables: {
          id: this.mockupID,
          busOrderMockup:{
          status: 0
          }
        }
      });
      if(result.data){
        // await this.$apollo.queries.busOrder.refetch()
        await this.busOrder()
        this.isApprove = false
        this.saveNotification()
      } else {
        this.errorNotification()
      }
    },
    async mockupRejection(rejectMessage){
      this.isSubmitRejection = true
      if(rejectMessage){
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/discussionAdd.gql'),
          errorPolicy: 'all',
          variables:{
            input:{
              comment: this.rejectMessage,
              file_type: this.userName,
              order:{
                id: parseInt(this.$route.params.id)
              }
            }
          }
        });
        if(result.data){
          const result2 = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/mutation/updateMockupStatus.gql'),
            errorPolicy: 'all',
            variables: {
              id: this.mockupID,
              busOrderMockup:{
              status: 1,
              note: this.rejectMessage
              }
            }
          });
          if(result2.data){
            // await this.$apollo.queries.busOrder.refetch()
            await this.busOrder()
            this.isSubmitRejection = false
            this.isReject = !this.isReject
            this.saveNotification()
            } else {
              this.errorNotification()
            }
        }else {
          this.errorNotification()
        }
      }else {
        this.errorNotification()
      }
    },
    resendMockup(index){
      (async () => {
        let data = {
          "id": this.id,
          "title": this.title,
          "type": "design approval",
          "images": this.images,
          "total_price": this.totalPrice
        }
        const response = await api.post(apiV2.busEmail, data, { needToken: true })
        if (response.status == 200) {
            this.$notify({
              group: 'saved',
              title: `Success`,
              text: 'Email has been sent!',
              type: 'success'
              });
        }
      })();
      this.toggleModal(1)
    },
     downloadImg(image_data){
      this.$http.get(image_data, {
        responseType: 'arraybuffer',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET',
            // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        })
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/ptestdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = image_data.split('/').pop()
        link.click()
      })
    },
    saveNotification(){
      this.$notify({
            group: 'saved',
            title: 'Success',
            text: 'Change Status Saved',
            type: 'success'
      });
    },
    errorNotification(){
      this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Change Status Failed!',
            type: 'warn'
      });
    },
    errorNotify(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .file-name {
    span {
      font-size: 12px;
      width: 100px;
      height: 16px;
      font-size: 12px;
      margin-top: 2px;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    i{
      margin-top: 3px;
      font-size: 16px;
      margin-left: 6px;
      color: #999999;
      cursor: pointer;
    }
  }

  
</style>